export default __webpack_public_path__ + "static/media/charge.43d79156.svg";